import { render, staticRenderFns } from "./NavigationTab.vue?vue&type=template&id=27b93c64&"
import script from "./NavigationTab.vue?vue&type=script&lang=js&"
export * from "./NavigationTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports